module.exports = __webpack_public_path__ + "assets/EquilateralByCentroid2PDetailed.fe89bdf82b8feb830f1f7b3642eff6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/EquilateralByCentroid2PDetailed.png
// module id = 510
// module chunks = 0